import { IDs } from './IDs';

export function getEigenstromTypen(data: any): any[] {
    return ((data || {})[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN] || []).sort((a: any, b: any) => {
        if (`${a.typ}_${a.name}` < `${b.typ}_${b.name}`) {
            return -1;
        }

        if (`${a.typ}_${a.name}` > `${b.typ}_${b.name}`) {
            return 1;
        }
        return 0;
    });
}
